import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
    >
      <path
        fill={color}
        d="M13.5433381,2.04333807 C13.8194781,2.04333807 14.0433381,2.26719807 14.0433381,2.54333807 L14.0433381,2.54333807 L14.0433381,6.04333807 L13.0433381,6.04333807 L13.0433381,3.04333807 L3.04333807,3.04333807 L3.04333807,13.0433381 L6.04333807,13.0433381 L6.04333807,14.0433381 L2.54333807,14.0433381 C2.26719807,14.0433381 2.04333807,13.8194381 2.04333807,13.5433381 L2.04333807,13.5433381 L2.04333807,2.54333807 C2.04333807,2.26719807 2.26719807,2.04333807 2.54333807,2.04333807 L2.54333807,2.04333807 Z M7.84880593,6.95110058 L13.1403585,12.24266 L13.1403443,9.06412092 L14.1411369,9.06411385 L14.1411369,13.4506815 C14.1411369,13.7270676 13.9171031,13.9511006 13.6407159,13.9511006 L13.6407159,13.9511006 L9.25413044,13.9511006 L9.25413044,12.9503191 L12.4326895,12.9503262 L7.14113692,7.65876672 L7.84880593,6.95110058 Z"
        fill-rule="nonzero"
        transform="rotate(-90 8.092237 8.043338)"
      />
    </svg>
  )
}

const ForwardIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default ForwardIcon
